import "./ServicesSection.module.css";
import PureDetailHeader from "@/reusable_sections/Header";
import ServicesOverview from "./sections/ServicesOverview";
import ServiceDetailsGrid from "./sections/ServiceDetailsGrid";
import PureAnswersForPureDetail from "./sections/PureAnswersForPureDetail";
import PureDetailFooter from "@/reusable_sections/Footer";
export default function ServicesSectionPage() {
  return <div>
      <PureDetailHeader />
      <ServicesOverview />
      <ServiceDetailsGrid />
      <PureAnswersForPureDetail />
      <PureDetailFooter />
    </div>;
}